import { render } from "./PriceDrops.vue?vue&type=template&id=261a1154&scoped=true"
import script from "./PriceDrops.vue?vue&type=script&lang=js"
export * from "./PriceDrops.vue?vue&type=script&lang=js"

import "./PriceDrops.vue?vue&type=style&index=0&id=261a1154&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261a1154"]])

export default __exports__